import { forwardRef, useState } from 'react';
import { cn } from '@/lib/cn';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  maxChars?: number;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, maxChars, onChange, value, id, ...props }, ref) => {
    const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
    const [charCount, setCharCount] = useState(
      typeof value === 'string' ? value.length : 0
    );

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCharCount(e.target.value.length);
      onChange?.(e);
    };

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={textareaId}
            className="block text-sm font-medium text-gray-300 mb-1.5"
          >
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          value={value}
          onChange={handleChange}
          className={cn(
            'input-dark w-full min-h-[100px] resize-y',
            error && 'border-error-500 focus:ring-error-500/50 focus:border-error-500',
            className
          )}
          maxLength={maxChars}
          {...props}
        />
        <div className="flex items-center justify-between mt-1">
          {error && (
            <p className="text-sm text-error-400">{error}</p>
          )}
          {maxChars && (
            <p
              className={cn(
                'text-xs ml-auto',
                charCount > maxChars * 0.9 ? 'text-warning-400' : 'text-gray-500'
              )}
            >
              {charCount}/{maxChars}
            </p>
          )}
        </div>
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
